<script>
/**
 * Los siguientes métodos controlan roles y permisos.
 * Si alguno de los permisos enviados como parámetro
 * se encuentra presente entre los del usuario
 * devuelve un valor true
 *
 * El método $can controla permisos
 * El método $role controla roles
 *
 * Los parámetros deben enviarse en forma de array
 */
export default {
  methods: {
    $can(permissions) {
      if (permissions && permissions.length) {
        const auth = JSON.parse(sessionStorage.getItem('auth'));
        const authPermissions = auth.role.permissions.map(per =>
          per.name.toLowerCase()
        );
        return permissions.some(
          per => authPermissions.toString().indexOf(per.toLowerCase()) > -1
        );
      }

      return true;
    },
    $role(roles) {
      if (roles && roles.length) {
        const auth = JSON.parse(sessionStorage.getItem('auth'));
        if (auth) {
          const authRoles = auth.role.roles.map(role => role.name.toLowerCase());

          var no = roles.filter(role => {return (role.split('!').length>1)}).map(role => {return role.replace('!', '')}).some(
            role => { return authRoles.toString().indexOf(role.toLowerCase()) > -1 }
          );

          if (no) { return false; }

          return roles.filter(role => {return !(role.split('!').length>1)}).some(
            role => { return authRoles.toString().indexOf(role.toLowerCase()) > -1 }
          );
        }
        /*desde aqui todo en true para los permisos en sidebar, ver esa logica*/
        return true;
      }

      return true;
    }
  }
};
</script>
